import decircular from 'decircular';
import { getCurrentInstance } from 'vue';
import { getTelemetryInstance } from '@src/telemetry/initialize';

export function getParentTree() {
  const tree = [];
  let instance = getCurrentInstance();

  while (instance && instance.parent) {
    const { parent } = instance;

    let tagName = 'Anonymous';

    // Check if parent is a native DOM element or a Vue component
    if (typeof parent.vnode.type === 'string') {
      // Native DOM element (e.g., 'div', 'span')
      tagName = parent.vnode.type;
    } else {
      // Vue component (Composition or Options API)
      // eslint-disable-next-line no-underscore-dangle
      tagName = parent.type.__name || parent.type.__file || 'Anonymous';
    }

    if (tagName !== 'Anonymous') tree.push(tagName);

    instance = parent;
  }

  return tree;
}

export default {
  mounted() {
    const { name = 'unnamed', sbComponentVersion = false } = this.$options;
    const props = this.$props || {};

    const event = decircular({
      name: 'DESIGN_SYSTEM_COMPONENT_USAGE',
      properties: {
        dsComponentProps: props,
        dsComponentName: name,
        dsComponentVersion: sbComponentVersion || props.version || '',
        dsComponentTree: getParentTree(),
        mfeLocation: window.location,
      },
    });

    getTelemetryInstance()?.trackEvent(event);
  },
};
